import { render, staticRenderFns } from "./roleHomeBase.vue?vue&type=template&id=31837d4f"
import script from "./roleHomeBase.vue?vue&type=script&lang=js"
export * from "./roleHomeBase.vue?vue&type=script&lang=js"
import style0 from "./roleHomeBase.vue?vue&type=style&index=0&id=31837d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports